import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Club } from '@court-sync/shared';

const STORAGE_KEY = 'courtsync-selected-club-id';

interface ClubContextState {
  selectedClubId: string | null;
  selectClub: (club: Club | null) => void;
  clearClubContext: () => void;
}

export const useClubContextStore = create<ClubContextState>()(
  persist(
    (set) => ({
      selectedClubId: null,

      selectClub: (club) => {
        set({ selectedClubId: club?.id ?? null });
      },

      clearClubContext: () => {
        set({ selectedClubId: null });
      },
    }),
    {
      name: STORAGE_KEY,
      partialize: (state) => ({ selectedClubId: state.selectedClubId }),
    }
  )
);
